/**
 * 房间宾客信息
 */
import React, { useMemo } from 'react';
import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import cls from 'classnames';
import intl from 'react-intl-universal';

import { parseFen2Currency } from '@/utils/number';
import ContentBlock from '@/components/Reservation/ContentBlock';
import { MemberType, MEMBER_TYPE_MAP } from '@/config/constant';
import { RoomGuestItem } from '@/redux/reducers/reservation/base.d';
import { MemberLevelItem } from '@/redux/reducers/guest';
import { TenantGlobalConfig } from '@/components/Intl/IntlContext/helper';

import styles from './index.module.scss';

interface IProps {
  title: string;
  dataSource: RoomGuestItem[];
  memberLevelMap: { [key: string]: MemberLevelItem };
}

const defaultRender = (val) => val || '—';

const Index: React.FC<IProps> = (props) => {
  const { title, dataSource, memberLevelMap } = props;

  const tableColumns = useMemo<ColumnsType<RoomGuestItem>>(() => {
    return [
      { title: intl.get('app_constants_guest_name'), dataIndex: 'roomNo', key: 'roomNo' },
      {
        title: intl.get('app_constants_room_no'),
        dataIndex: 'name',
        key: 'name',
        render: (val, record) => (
          <div className={styles.nameWrapper}>
            <span
              className={cls(
                styles.userRole,
                record.memberType === MemberType.HouseOwner ? styles.masterTag : null,
              )}
            >
              {MEMBER_TYPE_MAP[record.memberType]}
            </span>
            <span>{val}</span>
          </div>
        ),
      },
      {
        title: intl.get('app_reservation_cert_type'),
        dataIndex: 'certType',
        key: 'certType',
        render: (val) =>
          TenantGlobalConfig.getSystemConfig().certTypesMap?.[val] || defaultRender(val),
      },
      {
        title: intl.get('app_reservation_cert_number'),
        dataIndex: 'certNo',
        key: 'certNo',
        render: defaultRender,
      },
      // {
      //   title: intl.get('app_reservation_phone_number'),
      //   dataIndex: 'mobile',
      //   key: 'mobile',
      //   render: defaultRender,
      // },
      {
        title: intl.get('app_reservation_member_level'),
        dataIndex: 'memberLevel',
        key: 'memberLevel',
        render: (val) => memberLevelMap[val]?.name,
      },
      {
        title: intl.get('app_reservation_remain_balance'),
        dataIndex: 'remainingBalance',
        key: 'remainingBalance',
        align: 'right',
        render: (val) => parseFen2Currency(val),
      },
    ];
  }, [dataSource, memberLevelMap]);

  return (
    <ContentBlock title={title} className={styles.customerInfoContainer}>
      <Table
        pagination={false}
        className={styles.rentRoomContainer}
        rowKey="indexId"
        columns={tableColumns}
        dataSource={dataSource}
      />
    </ContentBlock>
  );
};

export default Index;
